<template>
    <div :style="'width: 100vw;background-size: 100vw 100vh;background-image: url('+bgimg+');'">
       
        <div class="cpimg">
            <div style="width: 95%;height: 40%;padding-left: 2.5%;padding-top: 6%;color: #818181;font-size: 10px;text-align: center;display: inline-block;">
                <img style="width: 10rem;height: 3rem;" src="../img/朗思介绍.png" alt="" srcset="">
                <div></div>
                <span class="jsfont" style="font-family:'JDZY' ;">
                    Langsi was founded in 2016,engaged in R&D, production and sales of smart cameras and smart lock products for more than 7years. We are a national high-tech and well known enterprise， leading solution provider and manufacturer of smart homecameras and smart locks in China.Wwe provide a one-stop OEM/ODM/OBM/JDM service for the products previously mentioned.In addition, all of our products comply with international quality standards and are greatly appreciated in a variety of differentmarkets throughout the world.
                </span>
                </div>
            
        </div>
        <div style="width: 100%;text-align: center;">
            <img class="img_js" style="" src="../img/朗思.png" alt="" srcset="">
            <div></div>
            <img class="img_js2" style="" src="../img/朗思介绍图片A.png" alt="" srcset="">
            <h1>OEM&ODM&JDM Service</h1>
            <img class="img_js3" style="" src="../img/aboutlangsi1.png" alt="">
            <div></div>
            <img class="img_js4" style="" src="../img/aboutlangsi.png" alt="">
        </div>
    </div>
</template>
<script>
import font from '../css/font.css'
import logo1 from '../img/logo1.png'
import bgimg from '../img/bg.png'
export default {
  name: 'aboutlangsi',//关于朗思
  data() {
    return {
        language:"EN",
        logo1:logo1,
        bgimg:bgimg,
    }
   },
  components: {

  }
}
</script>
<style>
h1{
    font-size: 2rem;
}
.jsfont{
    font-size: 1.5em;
}
.img_js4{
    width: 70rem;height:52rem;
}
.img_js3{
    width: 70rem;height:55rem;
}
.img_js2{
    width: 70rem;height: 30rem;margin-bottom: 30px;
}
.img_js{
    width: 70rem;height: 60rem;
}
  @media screen and (max-width: 700px) {
    h1{
        font-size: 0.5rem;
    }
    .img_js4{
        width: 70vw;height:52vw;
    }
    .img_js3{
        width: 70vw;height:55vw;
    }
    .img_js2{
        width: 100vw;height: 70vw;margin-bottom: 30px;
    }
    .img_js{
        width: 100vw;height: 90vw;
    }
    .jsfont{
    font-size: 0.5em;
}
  }
.cpimg{
    cursor: pointer;
    width: 100vw;
    height: 17rem;
}
</style>